<template>
  <div class="cas-modal-card modal-card is-desktop is-centered">
    <table width="100%">
      <header class="modal-card-head">
        <p class="modal-card-title">CAS Rejection Confirmation</p>
        <button type="button" class="delete" @click="$parent.close()" />
      </header>
      <section class="modal-card-body">
        <b-field :label="casRejectionReason.responseMessage">
          <a @click="loadCASRejectedItems" v-show="casRejectionReason.casCount"
            >Click here to see the Auto Rejected Items by CAS
          </a>
          <br />
          <a
            @click="loadKeywordsRejectedItems"
            v-show="casRejectionReason.keyWordCount"
            >Click here to see the Auto Rejected Items by Keywords
          </a>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">
          Close
        </button>
        <button
          class="button is-primary"
          type="button"
          @click="submitByCasConfirmation()"
        >
          OK
        </button>
      </footer>
    </table>
    <b-modal
      :active.sync="isCasItemsComponentModalActive"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <CasItems
        v-bind="itemProps"
        @goToHomePage="closeFormAfterSubmit"
      ></CasItems>
    </b-modal>
  </div>
</template>

<script>
import CasItems from "../components/CasItems.vue";
export default {
  name: "CasConfirmation",
  components: {
    CasItems
  },
  props: [
    "vcatList",
    "sIdForCASConfirm",
    "count",
    "pageSize",
    "casRejectionReason"
  ],
  data() {
    return {
      vcatsList: [],
      vcatNbrList: [],
      casCount: "",
      classes: "",
      submissionId: "",
      isCasItemsComponentModalActive: false,
      itemProps: {
        vcatList: [],
        count: "",
        pageSize: "",
        itemsBy: ""
      }
    };
  },
  methods: {
    loadCASRejectedItems: function() {
      var submissionFormScope = this;
      var args = {};
      args.headers = {
        "content-type": "application/json"
      };
      submissionFormScope.isLoading = true;
      submissionFormScope.$http
        .get(
          `${process.env.VUE_APP_API_BASE_DOMAIN}loadCASRejecteditems/submissionId/${this.sIdForCASConfirm}`,
          null,
          args
        )
        .then(function(response) {
          submissionFormScope.isLoading = false;
          submissionFormScope.itemProps.vcatList = response.data.vcatNbrList;
          submissionFormScope.itemProps.count = response.data.casCount;
          submissionFormScope.itemProps.pageSize =
            response.data.casCount <= 100 ? response.data.casCount : 100;
          submissionFormScope.itemProps.itemsBy = "CAS";
          submissionFormScope.isCasItemsComponentModalActive = true;
        })
        .catch(function(error) {
          submissionFormScope.isLoading = false;
          submissionFormScope.$buefy.dialog.alert({
            message: `Failed to load CAS rejected Items. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            confirmText: "OK"
          });
        });
    },
    loadKeywordsRejectedItems: function() {
      var submissionFormScope = this;
      var args = {};
      args.headers = {
        "content-type": "application/json"
      };
      submissionFormScope.isLoading = true;
      submissionFormScope.$http
        .get(
          `${process.env.VUE_APP_API_BASE_DOMAIN}loadKeyWordRejecteditems/submissionId/${this.sIdForCASConfirm}`,
          null,
          args
        )
        .then(function(response) {
          submissionFormScope.isLoading = false;
          submissionFormScope.itemProps.vcatList = response.data.vcatNbrList;
          submissionFormScope.itemProps.count = response.data.keyWordCount;
          submissionFormScope.itemProps.pageSize =
            response.data.keyWordCount <= 100
              ? response.data.keyWordCount
              : 100;
          submissionFormScope.itemProps.itemsBy = "Keywords";
          submissionFormScope.isCasItemsComponentModalActive = true;
        })
        .catch(function(error) {
          submissionFormScope.isLoading = false;
          submissionFormScope.$buefy.dialog.alert({
            message: `Failed to load CAS rejected Items. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            confirmText: "OK"
          });
        });
    },
    submitByCasConfirmation() {
      var submissionFormScope = this;
      var userData = "";
      this.submissionId = this.sIdForCASConfirm;
      if (sessionStorage.getItem("se_ni_user")) {
        userData = JSON.parse(sessionStorage.getItem("se_ni_user"));
      }
      submissionFormScope.isLoading = true;
      submissionFormScope.$http
        .get(
          `${process.env.VUE_APP_API_BASE_DOMAIN}casDataConfirmation?nbrNewItemCrKey=${this.sIdForCASConfirm}&nameUser=${userData.networkId}&status=S`
        )
        // eslint-disable-next-line no-unused-vars
        .then(function(response) {
          submissionFormScope.isLoading = false;
          submissionFormScope.$buefy.dialog.alert({
            message: `Action on Submission ID - ${submissionFormScope.submissionId} is successful.`,
            confirmText: "OK",
            type: "is-success",
            onConfirm: () => submissionFormScope.closeFormAfterSubmit()
          });
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          submissionFormScope.isLoading = false;
          submissionFormScope.$buefy.dialog.alert({
            message: error.response.data,
            confirmText: "OK",
            type: "is-danger"
          });
        });
    },
    closeFormAfterSubmit() {
      if (sessionStorage.getItem("se_ni_user")) {
        window.close();
      } else {
        this.$emit("refreshGrid", true);
        this.$emit("toggleSubmissionView", true);
      }
    }
  }
};
</script>
<style scoped></style>
